import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllRentalDuration = createAsyncThunk(
  'rentalDuration/getAllRentalDuration',
  async (params, thunkAPI) => {
    const { page, limit } = params;

    let newUrl = `/rental-duration-settings`;

    if (page) {
      if (newUrl.includes('?')) {
        newUrl += `&page=${page}`;
      } else {
        newUrl += `?page=${page}`;
      }
    }

    if (limit) {
      if (newUrl.includes('?')) {
        newUrl += `&limit=${limit}`;
      } else {
        newUrl += `?limit=${limit}`;
      }
    }

    try {
      const response = await axiosInstance.get(newUrl);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const getDetailRentalDuration = createAsyncThunk(
  'rentalDuration/getDetailRentalDuration',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/rental-duration-settings/${id}`);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const createRentalDuration = createAsyncThunk(
  'rentalDuration/createRentalDuration',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/rental-duration-settings`, { ...payload });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const updateRentalDuration = createAsyncThunk(
  'rentalDuration/updateRentalDuration',
  async (payload, thunkAPI) => {
    const { id, ...payloadData } = payload;

    try {
      const response = await axiosInstance.put(`/rental-duration-settings/${id}`, {
        ...payloadData,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const deleteRentalDuration = createAsyncThunk('rentalDuration/deleteRentalDuration', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/rental-duration-settings/${id}`);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});
